export default class QueryParentProperty
{
	remoteClass = "gongqi.erp.gotmodel.query.QueryParentProperty";
	tableId;
	tableName;
	aliasName;
}


// WEBPACK FOOTER //
// ./src/query/remote/QueryParentProperty.js